module.exports = __webpack_public_path__ + "static/media/betting_input.8bd3bb1f.png";